import { Injectable } from '@angular/core';
import { Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions } from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';
import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { DataTable } from 'primeng/components/datatable/datatable';

import { PlantMapService } from '../../plantmap/services/plant-map.service';
import { NceService } from '../../nce/services/nce.service';

import { FileService } from '../../shared/services/file.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { StorageService } from '../../shared/services/storage.service';
import { ErrorService } from '../../shared/services/error.service';
import { ValidationService } from '../../shared/services/validation.service';
import { PopupService } from '../../shared/services/pop-up.service';
import saveAs from "file-saver";
import { URL_SERVICE } from 'environments/environment';
import { CONFIGURATION } from 'app/shared/configuration/configuration';

@Injectable()
export class HistoryService {

    vTotalCustomerNCE: number = 0;
    vTotalCustomerPlantmap: number = 0;

    vLoadingStatus: boolean;

    vPlantLists: Array<{
        plant_record_id: number,
        plant_request_id: string,
        project_title: string,
        create_date: string,
        expiry_date: string,
        updated_date: string,
        location: string,
        a2_amount: string,
        status: string,
        trans_amount: string,
        check_status: string,
        registration_type: string,
        plant_map_s3_status: number,
        restricted_area: number,
        hourdiff: number

    }>;

    vNCELists: Array<{
        nce_record_id: number,
        nce_request_id: string,
        create_date: string,
        updated_date: string,
        location_earthwork: string,
        appointment_date: string,
        appointment_time: string,
        status: string
    }>;

    vPlantmapStatus: Array<{
        status: string,
        description: string
    }>

    vNCEStatus: Array<{
        status: string,
        description: string
    }>

    vPlantMapDetail: {
        plant_request_id: string,
        plant_record_id: number,
        project_title: string,
        location: string,
        main_contractor: string,
        restricted_area: number,
        a2_amount: number,
        trans_amount: string,
        trans_method: string,
        payment_received_date: string,
        printed_date: string,
        status: string,
        attachment: {},
        payment: number,
        hourdiff: number,
        review_feedback: boolean;
    }

    constructor(
        private _http: Http,
        private _plantmapService: PlantMapService,
        private _nceService: NceService,
        private _fileService: FileService,
        private _pageNavigationService: PageNavigationService,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _validationService: ValidationService,
        private _popupService: PopupService
    ) {
        this.vLoadingStatus = false;
        this.resetPlantMapDetail();
    }

    downloadZipFileFromDMS(fileName) {
        this.vLoadingStatus = true;
        let bdy = {
            "fileName": fileName,
            "userGroup": "PRP System Service Account"
        }

        let HTTPOptions: Object = {

            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ZG1zYXBpOmRtc2FwaTEyMw==',
            }),
            responseType: 2
        }

        this._http.post(URL_SERVICE[CONFIGURATION.modeEnv].DMS_DOWNLOAD_URL, bdy, HTTPOptions).subscribe(
            (response: any) => {
                const blob = new Blob([response], {
                    type: 'application/zip'
                });
                saveAs(blob, fileName);
                this.vLoadingStatus = false;
            },
            (error) => {
                console.error('Error downloading file', error);
                this.vLoadingStatus = false; // Set to false on error
            }
        );
    }
    downloadInvoiceFromDMS(fileName) {
        let bdy = {
            "fileName": fileName,
            "userGroup": "PRP System Service Account"
        }

        let HTTPOptions: Object = {

            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ZG1zYXBpOmRtc2FwaTEyMw==',
            }),
            responseType: 2
        }
        this._http.post(URL_SERVICE[CONFIGURATION.modeEnv].DMS_DOWNLOAD_URL, bdy, HTTPOptions).subscribe((response: any) => {
            const blob = new Blob([response], {
                type: 'application/pdf'
            });
            saveAs(blob, fileName)
        }
        )
    }

    getTotalCustomerPlantmap() {
        return this.vTotalCustomerPlantmap;
    }

    getTotalCustomerNCE() {
        return this.vTotalCustomerNCE;
    }

    getCustomerPlantList() {
        return this.vPlantLists;
    }

    getNCEList() {
        return this.vNCELists;
    }

    getAllPlantStatus() {
        return this.vPlantmapStatus;
    }

    getAllNCEStatus() {
        return this.vNCEStatus;
    }

    getPlantmapDetail() {
        return this.vPlantMapDetail;
    }

    isLoading() {
        return this.vLoadingStatus;
    }
    //Anjaiah
    getExprityDateCheck() {
        var currentdate = new Date();
        var timeZone = ((currentdate.getHours()) >= 12) ? 'PM' : 'AM';
        var expityDataCheck = (currentdate.getDate() < 10 ? '0' : '') + currentdate.getDate() + "/"
            + (currentdate.getMonth() + 1 < 10 ? '0' : '') + (currentdate.getMonth() + 1) + "/"
            + (currentdate.getFullYear() < 10 ? '0' : '') + currentdate.getFullYear() + " "
            + (currentdate.getHours() < 10 ? '0' : '') + currentdate.getHours() + ":"
            + (currentdate.getMinutes() < 10 ? '0' : '') + currentdate.getMinutes() + timeZone;
        return expityDataCheck;
    }
    resetPlantMapDetail() {
        this.vPlantMapDetail = {
            plant_request_id: '',
            plant_record_id: 0,
            project_title: '',
            location: '',
            main_contractor: '',
            restricted_area: 0,
            a2_amount: 0,
            trans_amount: '',
            trans_method: '',
            payment_received_date: '',
            printed_date: '',
            status: '',
            attachment: {},
            payment: -1,
            hourdiff: 0,
            review_feedback: null
        }
    }

    loadPlantmap(pPageNumber, pPageSize, pSearchBy, pFilterBy, pPlantStatus, pSortorder, pSortfield) {
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_USER_PLANTMAP + '?page_number=' + pPageNumber +
            '&page_size=' + pPageSize + '&search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pPlantStatus +
            '&sortorder=' + pSortorder + '&sortfield=' + pSortfield);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPlantLists = vResponseData.data.plantmaps;

                    this.vPlantLists.forEach((element, index) => {
                        let tempTransAmount = '';
                        tempTransAmount = 'SGD ' + parseFloat(element.trans_amount).toFixed(2);
                        element.trans_amount = tempTransAmount;
                    });

                    resolve();
                },
                (error) => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadPlantmapDate(pPageNumber, pPageSize, pSearchBy, pFromDateFilterBy, pToDateFilterBy, pPlantStatus, pSortorder, pSortfield) {
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_USER_PLANTMAP_DATE + '?page_number=' + pPageNumber +
            '&page_size=' + pPageSize + '&search_by=' + pSearchBy + '&fromdatefilter_by=' + pFromDateFilterBy + '&todatefilter_by=' + pToDateFilterBy + '&status=' + pPlantStatus
            + '&sortorder=' + pSortorder + '&sortfield=' + pSortfield);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPlantLists = vResponseData.data.plantmaps;

                    this.vPlantLists.forEach((element, index) => {
                        let tempTransAmount = '';
                        tempTransAmount = 'SGD ' + parseFloat(element.trans_amount).toFixed(2);
                        element.trans_amount = tempTransAmount;
                    });

                    resolve();
                },
                (error) => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadNCE(pPageNumber, pPageSize, pSearchBy, pFilterBy, pNCEStatus) {
        var promise = this._http.get(API_ENDPOINTS.NCE.GET_ALL_NCE + '?page_number=' + pPageNumber + '&page_size=' +
            pPageSize + '&search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pNCEStatus);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vNCELists = vResponseData.data.nceapplications;
                    resolve();
                },
                (error) => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadAllPlantStatus() {
        let data = this._storageService.getSessionItem('allPlantStatus');
        if (data !== null) {
            this.vPlantmapStatus = JSON.parse(data);
        } else {
            this._http.get(API_ENDPOINTS.PLANT_MAP.GET_ALL_STATUS).subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vPlantmapStatus = vResponseData.data.status;
                    this._storageService.setSessionItem('allPlantStatus', JSON.stringify(this.vPlantmapStatus));
                },
                (error) => {
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    console.log(error);
                }
            );
        }
    }

    loadAllNCEStatus() {
        let data = this._storageService.getSessionItem('allNCEStatus');
        if (data !== null) {
            this.vNCEStatus = JSON.parse(data);
        } else {
            this._http.get(API_ENDPOINTS.NCE.GET_ALL_STATUS).subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vNCEStatus = vResponseData.data.status;
                    this._storageService.setSessionItem('allNCEStatus', JSON.stringify(this.vNCEStatus));
                },
                (error) => {
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    console.log(error);
                }
            );
        }
    }

    loadTotalCustomerPlant(pSearchBy, pFilterBy, pPlantStatus) {
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_USER_TOTAL_PLANTMAP + '?search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pPlantStatus);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vTotalCustomerPlantmap = vResponseData.data.total_plantmap;
                    resolve();
                },
                (error) => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadTotalCustomerPlantDate(pSearchBy, pFromDateFilterBy, pToDateFilterBy, pPlantStatus) {
        var promise = this._http.get(API_ENDPOINTS.PLANT_MAP.GET_USER_TOTAL_PLANTMAP_DATE + '?search_by=' + pSearchBy + '&fromdatefilter_by=' + pFromDateFilterBy + '&todatefilter_by=' + pToDateFilterBy + '&status=' + pPlantStatus);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vTotalCustomerPlantmap = vResponseData.data.total_plantmap;
                    resolve();
                },
                (error) => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadTotalCustomerNCE(pSearchBy, pFilterBy, pNCEStatus) {
        var promise = this._http.get(API_ENDPOINTS.NCE.GET_TOTAL_NCE + '?search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pNCEStatus);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    this.vTotalCustomerNCE = vResponseData.data.total_nceapplications;
                    resolve();
                },
                (error) => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                });
        });
        return p;
    }

    loadDetailPlantMap(pPlantMapID) {
        this.vLoadingStatus = true;
        this._http.get(API_ENDPOINTS.PLANT_MAP.GET_DETAIL_PLANTMAP + '?plant_record_id=' + pPlantMapID).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData: any = response;
                console.log(vResponseData);
                this.vPlantMapDetail = vResponseData.data.plantmaps;
                //Anjaiah start        
                let pmByPlantID = this.vPlantLists.filter(
                    plantstatus => plantstatus.plant_request_id === this.vPlantMapDetail.plant_request_id);
                /*console.log('check :',pmByPlantID[0].create_date);
                let createDate = pmByPlantID[0].create_date.split(" ",2);
                let orderDate = createDate[0];
                let time = createDate[1];
                var slash = time.split(":",3);
                let hourNumber = Number(slash[0]);
                let AMPM = slash[1];
                AMPM = AMPM.substr(2,4);
                console.log('AM or PM:',AMPM);
                if(AMPM == "PM" && hourNumber<12) hourNumber = hourNumber+12;
                if(AMPM == "AM" && hourNumber==12) hourNumber = hourNumber-12;
                console.log('Order Hour:',hourNumber);
                let currentDate = new Date();
                console.log('Current Date: ',this.getExprityDateCheck());
                let cDateSplice = this.getExprityDateCheck().split(" ",2);
                let todayDate = cDateSplice[0];
                console.log('Date: ',todayDate);
                let currnetHour = currentDate.getHours();
                console.log('Current Hour:',currnetHour);
                let hoursDiff = currnetHour - hourNumber;*/
                console.log('Difference :', this.vPlantMapDetail.hourdiff);
                //Anjaiah end
                if ((this.vPlantMapDetail.hourdiff <= 24 && (this.vPlantMapDetail.status === STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_PENDING ||
                    this.vPlantMapDetail.status === STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_FAILED ||
                    this.vPlantMapDetail.status === STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_CANCELLED ||
                    this.vPlantMapDetail.status === STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_CANCELLED_BY_MERCHANT) && this.vPlantMapDetail.review_feedback)
                ) {
                    // to prevent payment retry mechanism from My order after unsuccessful payment and also allow admin approved
                    // maps with restricted area to have payment page once approved.

                    this.continuePlantPayment(vResponseData.data.plantmaps);
                } else {
                    if (this.vPlantMapDetail.trans_method === STATIC_VALUE.PAYMENT_METHOD.creditCard.key) {
                        this.vPlantMapDetail.trans_method = STATIC_VALUE.PAYMENT_METHOD.creditCard.value
                    } else if (this.vPlantMapDetail.trans_method === STATIC_VALUE.PAYMENT_METHOD.enets.key) {
                        this.vPlantMapDetail.trans_method = STATIC_VALUE.PAYMENT_METHOD.enets.value
                    } else if (this.vPlantMapDetail.trans_method === STATIC_VALUE.PAYMENT_METHOD.dash.key) {
                        this.vPlantMapDetail.trans_method = STATIC_VALUE.PAYMENT_METHOD.dash.value
                    }

                    this.openViewDetailPopup();
                }
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    continuePlantPayment(vResponseData: any) {
        this._plantmapService.vPlantMapData = {
            plant_record_id: vResponseData.plant_record_id,
            plant_request_id: vResponseData.plant_request_id,
            onepay_reference_id: "",
            merchant: "",
            result: "",
            session_id: "",
            session_update_status: "",
            session_version: "",
            success_indicator: "",
            orderId: "",
            orderRef: "",
            transRef: ""
        }
        this._storageService.setSessionItem('plantMapData', JSON.stringify(this._plantmapService.vPlantMapData));
        this._plantmapService.vEarthworkDetailsData = {
            project_title: vResponseData.project_title,
            location: vResponseData.location,
            main_contractor: vResponseData.main_contractor,
            purchaser_company_name: vResponseData.purchaser_company_name,
            Purpose_Radiobutton: vResponseData.Purpose_Radiobutton,
            purpose_of_planmap_Others: vResponseData.purpose_of_planmap_Others

        }
        this._storageService.setSessionItem('plantMapEarthWork', JSON.stringify(this._plantmapService.vEarthworkDetailsData));
        this._plantmapService.vAreaOfInterestData = {
            a2_amount: vResponseData.a2_amount,
            restricted_area: vResponseData.restricted_area,
            amount_payable: vResponseData.trans_amount,
            coordinate11: vResponseData.coordinate[0][0],
            coordinate12: vResponseData.coordinate[0][1],
            coordinate21: vResponseData.coordinate[1][0],
            coordinate22: vResponseData.coordinate[1][1],
            coordinate31: vResponseData.coordinate[2][0],
            coordinate32: vResponseData.coordinate[2][1],
            coordinate41: vResponseData.coordinate[3][0],
            coordinate42: vResponseData.coordinate[3][1],
            flow: 'hisrory'
        }
        this._storageService.setSessionItem('plantMapAreaInterest', JSON.stringify(this._plantmapService.vAreaOfInterestData));
        this._fileService.vFiles = vResponseData.attachment.restricted_area !== undefined ? vResponseData.attachment.restricted_area : [];
        this._storageService.setSessionItem('plantmapFiles', JSON.stringify(this._fileService.vFiles));
        this._plantmapService.vPaymentData = {
            quantity: vResponseData.a2_amount,
            unitPrice: vResponseData.unit_price,
            totalPrice: vResponseData.trans_amount,
            paymentMethod: ""
        }
        this._storageService.setSessionItem('plantMapPayment', JSON.stringify(this._plantmapService.vPaymentData));
        this._pageNavigationService.navigate(["plant-map/payment"]);
    }

    openViewDetailPopup() {
        this._popupService.openPopup('view-plantmap', {
            title: 'Plant Map Reference No: ',
            buttons: {
                CANCEL: {
                    text: 'Cancel',
                    function: () => {
                        this._popupService.closePopup();
                        this.resetPlantMapDetail();
                    }
                }
            },
        });
    }

    loadNCEStatus(pNCEID) {
        this.vLoadingStatus = true;
        this._http.get(API_ENDPOINTS.NCE.GET_STATUS + '?nce_record_id=' + pNCEID).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData: any = response;
                console.log(vResponseData);
                let status = vResponseData.data.status;
                if (status === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_PENDING ||
                    status === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_FAILED) {
                    this.continueNCEPayment(pNCEID);
                    // } else if(status === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD){
                    //     this._nceService.getNCEID().nce_record_id = pNCEID;
                    //     let vLink = ['nce-application/appointment-upload']
                    //     this._pageNavigationService.navigate(vLink);
                } else if (status === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL) {
                    this._nceService.getNCEID().nce_record_id = pNCEID;
                    let vLink = ['nce-application/apply-for-final-approval']
                    this._pageNavigationService.navigate(vLink);
                }
                else {
                    let vLink = ['nce-application/view/' + pNCEID]
                    this._pageNavigationService.navigate(vLink);
                }
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    continueNCEPayment(pNCEID) {
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.NCE.PREVIEW + '?nce_record_id=' + pNCEID);
        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);

                    this._nceService.mapDataToNCE(vResponseData.data);

                    if (vResponseData.data.nceapplications.nce_request_id.slice(-2) === '-1') {
                        this._nceService.vFillInParticulars.plant_record_id = vResponseData.data.nceapplications.plant_record_id;
                        this._nceService.vFillInParticulars.plant_request_id = vResponseData.data.nceapplications.plant_request_id;

                        this.mapRemainingDataToNCE(vResponseData);

                        this._storageService.setSessionItem('extensionNCE', '0');
                        this._pageNavigationService.navigate(['nce-application/payment']);
                    } else {
                        this.vLoadingStatus = true;
                        this._nceService.loadReferenceID(pNCEID).then(
                            (resolve) => {
                                this.vLoadingStatus = false;
                                let data = resolve['data'];
                                this._nceService.vFillInParticulars.nce_record_id = data.prev_record_id;
                                this._nceService.vFillInParticulars.nce_request_id = data.prev_request_id;

                                this._storageService.setSessionItem('extensionNCE', '1');

                                this.mapRemainingDataToNCE(vResponseData);
                                this._pageNavigationService.navigate(['nce-application/payment']);
                            },
                            (reject) => {
                                this.vLoadingStatus = false;
                            }
                        );
                    }
                },
                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                });
        });
    }

    mapRemainingDataToNCE(vResponseData) {
        this._nceService.vNCEData.nce_record_id = vResponseData.data.nceapplications.nce_record_id.toString();
        this._nceService.vNCEData.nce_request_id = vResponseData.data.nceapplications.nce_request_id.toString();
        this._storageService.setSessionItem('nceData', JSON.stringify(this._nceService.vNCEData));

        this._nceService.vFillInParticulars.prev_request_id = vResponseData.data.nceapplications.prev_request_id;
        this._nceService.vFillInParticulars.nce_reference_id = vResponseData.data.nceapplications.nce_reference_id;
        this._nceService.vFillInParticulars.contract_end = vResponseData.data.nceapplications.contract_end;
        this._storageService.setSessionItem('nceParticulars', JSON.stringify(this._nceService.vFillInParticulars));

        this._nceService.vEarthworkDetails.duration_from_date = vResponseData.data.nceapplications.duration_from_date;
        this._nceService.vEarthworkDetails.duration_to_date = vResponseData.data.nceapplications.duration_to_date;
        this._nceService.vEarthworkDetails.actual_start_date = vResponseData.data.nceapplications.actual_start_date;
        this._nceService.vEarthworkDetails.estimate_end_date = vResponseData.data.nceapplications.estimate_end_date;
        this._nceService.vEarthworkDetails.already_start = vResponseData.data.nceapplications.already_start;

        this._storageService.setSessionItem('nceEarthwork', JSON.stringify(this._nceService.vEarthworkDetails));
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/history/services/history.service.ts